import React, { useCallback } from 'react';
import { Box, Button } from '@mui/material';
import styles from './cost-report-filter-bar.module.scss';
import { useCostReportSearch } from '../../search';
import CostReportFilter from '../top-bar/component/filter';
import { FilterState } from '../top-bar/component/filter/types';
import { useAppSelector } from '../../../../hooks/hooks';
import { updateTimeTrackingPropertyFilter } from '../../../../features/time-tracking-filters';
import SearchInput from '../../../../components/shared/search-input';
import { SVGS } from '../../../../assets/images';
import AmountSummary from '../../../../components/shared/amount-summary';
import { REmployees } from '../../../../features/roles/types';

interface Props {
    loading: boolean;
    hasActiveFilters: boolean;
    onResetFilters: () => void;
    totalAmount: number;
    disabled?: boolean;
    employees?: REmployees[];
    disableEmployeesFilter?: boolean;
}

export const CostReportFilterBar = ({ loading, hasActiveFilters, onResetFilters, totalAmount, disabled, employees, disableEmployeesFilter }: Props) => {
    const { change: searchChange, value: search } = useCostReportSearch();
    const propertyFilter = useAppSelector((selector) => selector.timeTrackingFilters.filter.propertyFilter);
    const ready = loading === undefined || !loading;

    const handlePropertyFilterChanged = useCallback((value: FilterState) => {
        updateTimeTrackingPropertyFilter({
            ...propertyFilter,
            selectedEmployees: value.selectedEmployees ?? [],
        });
        return Promise.resolve();
    }, [propertyFilter]);

    return (
        <Box className={styles.container}>
            <div className={styles.searchFilter}>
                <div className={styles.searchField}>
                    <SearchInput
                        searchValue={search}
                        onChange={searchChange}
                        width='260px'
                        disabled={disabled}
                    />
                </div>
                <div className={styles.filterControls}>
                    <CostReportFilter
                        onChange={handlePropertyFilterChanged}
                        disabled={disabled}
                        employees={employees}
                        disableEmployeesFilter={disableEmployeesFilter}
                    />
                    {ready && hasActiveFilters ? (
                        <Button className={styles.resetButton} onClick={onResetFilters} disabled={disabled}>
                            <SVGS.CancelIcon className={styles.fill} />
                        </Button>
                    ) : null}
                </div>
            </div>
            <div className={styles.summary}>
                <AmountSummary value={totalAmount} />
            </div>
        </Box>
    );
};

export default CostReportFilterBar;
